export const hasRole = (role, user) => {
  if (!role || !user) {
    return false;
  }

  return (
    (user[`${process.env.NX_AUTH0_NAMESPACE}/roles`] || []).indexOf(role) !== -1
  );
};
